@if (enableUpsellMMB && category === Category.CABIN_BAGGAGE && !isInfant) {
  <fin-titled-card
    [title]="
      'MMB.includedProducts.cabinBaggage.capacityTitle'
        | finLocalization
          : {
              amount: cabinWeight,
            }
    "
  >
    <ng-container *ngTemplateOutlet="serviceList" />
  </fin-titled-card>
}

@if (enableUpsellMMB && category === Category.CABIN_BAGGAGE && isInfant) {
  <div class="flex">
    <button
      [attr.aria-controls]="'infant-allowance-title'"
      [attr.aria-expanded]="expandOpen"
      class="fill flex no-outline"
      (click)="expandOpen = !expandOpen"
    >
      <div class="font-body-1 bold-type nordic-blue-300-text ms-xlarge-l font-body-medium-bold">
        {{ 'MMB.includedProducts.cabinBaggage.infantAllowance' | finLocalization }}
      </div>
      <fcom-icon
        class="flex-1 flex--nogrow rotate icon-medium nordic-blue-900-text text-icon-primary ms-medium-l"
        [class.rotate-active]="expandOpen"
        [name]="SvgLibraryIcon.CHEVRON_DOWN"
      />
    </button>
  </div>
  <fcom-expand
    class="block"
    [open]="expandOpen"
    [ariaId]="'infant-allowance-title'"
    [ariaLabelledBy]="'infant-allowance-item'"
  >
    <div class="flex flex--column">
      <ng-container *ngTemplateOutlet="serviceList" />
    </div>
  </fcom-expand>
}

@if (!enableUpsellMMB || category !== Category.CABIN_BAGGAGE) {
  <ng-container *ngTemplateOutlet="serviceList" />
}

<ng-template #serviceList>
  <ul class="no-list-style">
    @for (cat of filteredGroupedServices; let first = $first; track cat) {
      <li [class.ps-xsmall-t]="!first">
        @if ((enableUpsellMMB && !isInfant) || !enableUpsellMMB) {
          <div class="flex flex--middle" [class.ms-medium-l]="enableUpsellMMB">
            @if (cat.icon) {
              <fcom-icon [name]="cat.icon" class="icon-medium ms-xsmall-r" />
            }
            @if (cat.key !== 'availableForSell') {
              <div class="font-body-1 medium-type font-label-medium">
                {{ 'MMB.includedProducts.serviceCategory.' + cat.key + '.title' | finLocalization }}
              </div>
            }
            @if ((enableUpsellMMB || isCartMode()) && cat.key === 'pendingPayment') {
              <div class="flex ms-small-l ms-medium-r flex-1 flex--space-between">
                @if (cat.showActionsButtons && shouldShowModifyButton()) {
                  <fcom-link
                    [disabled]="serviceModifyProgress()"
                    [attr.data-testid]="'modify-button-' + this.category"
                    (afterNavigation)="onSelectProduct(cat.services[0])"
                  >
                    {{ 'actions.modify' | finLocalization }}
                  </fcom-link>
                }

                @if (cat.showActionsButtons && shouldShowPayButton()) {
                  <fcom-link
                    [disabled]="serviceModifyProgress()"
                    [attr.data-testid]="'modify-button-' + this.category"
                    (afterNavigation)="continuePurchase.emit(true)"
                  >
                    {{ 'actions.pay' | finLocalization }}
                  </fcom-link>
                }
              </div>
            }
          </div>
        }

        <ul class="accommodate-icon list-disc-style">
          @for (service of cat.services; let last = $last; track service) {
            <li>
              <div class="flex flex--wrap flex--align-start flex--self-stretch">
                @if (cat.key !== 'availableForSell') {
                  <span
                    class="regular-type fill"
                    [ngClass]="{
                      'pr-small-b': !last && isCartMode(),
                    }"
                    data-testid="grouped-services-product-name"
                  >
                    <ng-container
                      [ngTemplateOutlet]="
                        category === Category.SEAT && !service.seatNumber ? seatTags : serviceNameTemplate
                      "
                      [ngTemplateOutletContext]="{
                        serviceInfo: { service, pendingPayment: cat.key === 'pendingPayment' },
                      }"
                    />
                  </span>
                }
                @if (cat.key === 'availableForSell') {
                  <div
                    class="flex flex--space-between"
                    [ngClass]="{
                      'flex--column': isMobile(),
                      'flex--row flex-1': !isMobile(),
                    }"
                  >
                    <span class="regular-type mr-xsmall-r grey-600-text text-icon-disabled-text">
                      {{ 'MMB.includedProducts.availableForSell.' + service.subCategory + '.text' | finLocalization }}
                    </span>
                    @if (shouldShowAddButton()) {
                      <div class="flex flex--column">
                        <div
                          class="flex font-body-2 nordic-blue-300-text font-body-small"
                          [class.flex--end]="!isMobile()"
                          [class.ms-xsmall-t]="isMobile()"
                        >
                          {{ 'actions.from' | finLocalization }}
                        </div>
                        <div
                          class="flex font-heading-5 bold-type ms-xxsmall-y"
                          [class.flex--end]="!isMobile()"
                          [attr.data-testid]="`add-ancillary-${category}-text`"
                        >
                          {{ service.totalPrice | finPrice }}
                          @if (service.points) {
                            <span
                              class="font-body-1 medium-type ps-xxsmall-l flex flex--middle font-label-medium"
                              data-testid="product-card-avios-price"
                            >
                              /
                              <fcom-icon class="icon-small ms-xxsmall-x" [name]="SvgLibraryIcon.AVIOS_CURRENCY" />
                              {{ service.points | finPoints }}
                              {{ 'ancillaries.benefits.labels.plusPoints' | finLocalization }}
                            </span>
                          }
                        </div>

                        <div class="flex ms-xsmall-t" [class.flex--end]="!isMobile()">
                          @if (isMobile()) {
                            <fcom-icon-button
                              [attr.data-testid]="`add-ancillary-${category}`"
                              [icon]="{ name: SvgLibraryIcon.PLUS }"
                              [aria]="{ label: 'actions.add' | finLocalization }"
                              [theme]="IconButtonTheme.LIGHT_SECONDARY_OUTLINE"
                              [disabled]="!service.modifyInProgress && serviceModifyProgress()"
                              (clickBtn)="onSelectProduct(service)"
                            />
                          } @else {
                            <fcom-button
                              [attr.data-testid]="`add-ancillary-${category}`"
                              [icon]="{ name: SvgLibraryIcon.PLUS, position: IconPosition.RIGHT }"
                              [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
                              [loading]="service.modifyInProgress"
                              [disabled]="!service.modifyInProgress && serviceModifyProgress()"
                              [mode]="ButtonMode.FILL_MOBILE"
                              [text]="'actions.add' | finLocalization"
                              (clickBtn)="onSelectProduct(service)"
                            />
                          }
                        </div>
                      </div>
                    }
                  </div>
                }
                @if (service.includedInTierBenefit && service.parameters?.isCorporate) {
                  <fcom-tag>
                    <fcom-icon [name]="SvgLibraryIcon.B2B" class="icon-medium ms-xxsmall-r" />
                    <span class="regular-type">
                      {{ 'MMB.includedProducts.corporateBenefitTag' | finLocalization }}
                    </span>
                  </fcom-tag>
                } @else if (cat.tierLevel && service.includedInTierBenefit) {
                  <fcom-tag>
                    <fcom-icon [name]="SvgLibraryIcon.FINNAIR_PLUS" class="icon-medium ms-xxsmall-r" />
                    <span class="regular-type">{{
                      'MMB.includedProducts.chip.text' | finLocalization: { tier: cat.tierLevel }
                    }}</span>
                  </fcom-tag>
                }
              </div>
            </li>
          }
        </ul>
      </li>
    }
  </ul>
</ng-template>

<ng-template #seatTags let-serviceInfo="serviceInfo">
  @if (isCarrierConnect && isNotIncludedService(serviceInfo.service)) {
    <fcom-tag>
      <fcom-icon [name]="SvgLibraryIcon.INFO_BLOCK" class="icon-small ms-xxsmall-r" />
      <span class="regular-type">{{ 'MMB.services.seat.checkBoardingPassStatus' | finLocalization }}</span>
    </fcom-tag>
  }
  @if (isNotIncludedService(serviceInfo.service) && !isCarrierConnect && !enableUpsellMMB) {
    <fcom-tag [theme]="TagTheme.WARNING">
      <fcom-icon [name]="SvgLibraryIcon.ALERT_TRIANGLE" class="icon-small ms-xxsmall-r" />
      <span class="regular-type">{{ 'MMB.services.seat.assignedAtAirportStatus' | finLocalization }}</span>
    </fcom-tag>
  }
  @if (!isNotIncludedService(serviceInfo.service)) {
    <ng-container [ngTemplateOutlet]="serviceNameTemplate" [ngTemplateOutletContext]="{ serviceInfo: serviceInfo }" />
  }
</ng-template>

<ng-template #serviceNameTemplate let-serviceInfo="serviceInfo">
  <div class="flex flex-1 flex--space-between flex--middle mr-xsmall-r">
    <ng-container
      [ngTemplateOutlet]="serviceListing"
      [ngTemplateOutletContext]="{
        service: serviceInfo.service,
      }"
    />

    @if (shouldShowRemoveButton() && serviceInfo.pendingPayment) {
      <div
        [attr.data-testid]="
          'service-price-' +
          this.category +
          '-' +
          (this.category === Category.SEAT ? serviceInfo.service.seatNumber : serviceInfo.service.variant)
        "
        class="bold-type font-heading-5 font-title-small nowrap"
      >
        {{ serviceInfo.service.totalPrice | finPrice }}
      </div>
    }
  </div>

  @if (shouldShowRemoveButton() && serviceInfo.pendingPayment) {
    <div class="flex ms-small-l flex-1 flex--end">
      <fcom-button
        [attr.data-testid]="
          'remove-service-button-' +
          this.category +
          '-' +
          (this.category === Category.SEAT ? serviceInfo.service.seatNumber : serviceInfo.service.variant)
        "
        [theme]="ButtonTheme.LIGHT_TERTIARY_GHOST"
        [icon]="{ category: IconLibrary.SVG_LIBRARY, name: SvgLibraryIcon.TRASH, position: IconPosition.LEFT }"
        [loading]="serviceInfo.service.modifyInProgress"
        [text]="'MMB.reviewPage.service.removeButtonTitle' | finLocalization"
        [disabled]="serviceInfo.service.modifyInProgress === false && serviceModifyProgress()"
        [aria]="{
          loadingLabel: 'actions.loading' | finLocalization,
        }"
        (clickBtn)="onRemoveProduct(serviceInfo.service)"
      />
    </div>
  }
</ng-template>

<ng-template #serviceListing let-service="service">
  {{
    service.includedInTierBenefit || service.useDisplayName
      ? service.displayName
      : ('MMB.includedProducts.' + service.subCategory + '.text'
        | finLocalization
          : {
              seatNumber: service.seatNumber,
              amount: service.quantity,
              weight: service.parameters?.baggageWeight,
              displayName: service.displayName,
              seatType: service.seatTypeLabel | finLocalization,
            }
        | finEmpty: service.displayName)
  }}
</ng-template>
